export const isValidDefaultCommunitySearch = (value) => {
    if (value.type !== "locationFilter") {
        return true;
    }
    return value.city.trim().length > 0 || value.zip.trim().length > 0;
};
export var CommunityCardContactMode;
(function (CommunityCardContactMode) {
    CommunityCardContactMode["All"] = "All";
    CommunityCardContactMode["Primary"] = "Primary";
    CommunityCardContactMode["None"] = "None";
})(CommunityCardContactMode || (CommunityCardContactMode = {}));
export const allInvoiceSettingsKeys = [
    "invoicePayableName",
    "invoicePayableAddress",
    "invoicePayableCity",
    "invoicePayableState",
    "invoicePayableZip",
    "invoicePayablePhone",
    "invoicePayableEmail",
    "invoicePayableNotes",
    "defaultDaysBeforeInvoiceDue",
    "invoiceDefaultNotes",
];
export const allCommunitySearchSettingsKeys = [
    "defaultCommunitySearch",
    "defaultState",
    "communityCardContactMode",
    "enableBulkCommunityOptions",
];
export var EntityRegionPermissionType;
(function (EntityRegionPermissionType) {
    EntityRegionPermissionType["Member"] = "Member";
    EntityRegionPermissionType["Implied"] = "Implied";
})(EntityRegionPermissionType || (EntityRegionPermissionType = {}));
export var EntityRegionModeInput;
(function (EntityRegionModeInput) {
    EntityRegionModeInput["IncludeDescendants"] = "IncludeDescendants";
    EntityRegionModeInput["LocalOnly"] = "LocalOnly";
})(EntityRegionModeInput || (EntityRegionModeInput = {}));
export var EntityRegionModeOutput;
(function (EntityRegionModeOutput) {
    EntityRegionModeOutput["IncludeDescendants"] = "IncludeDescendants";
    EntityRegionModeOutput["LocalOnly"] = "LocalOnly";
    EntityRegionModeOutput["Inherited"] = "Inherited";
})(EntityRegionModeOutput || (EntityRegionModeOutput = {}));
export const defaultTimezone = "America/Los_Angeles";
export function defaultTenantSettings() {
    return {
        showClientFirst: false,
        showClientIntakeWeight: true,
        showClientIntakeHeight: true,
        showPhysicianContacts: false,
        showInsuranceInfo: false,
        showOngoingStatus: false,
        showCommunitySummaryOnComparisonChart: false,
        showCommunityRecordsInCommunityComparePDF: false,
        communityCardContactMode: CommunityCardContactMode.All,
        ownedReferralSources: false,
        defaultCommunitySearch: { type: "allCommunities", state: "" },
        defaultState: "",
        invoicePayableName: "",
        invoicePayableAddress: "",
        invoicePayableCity: "",
        invoicePayableState: "",
        invoicePayableZip: "",
        invoicePayableEmail: "",
        invoicePayableNotes: "",
        invoicePayablePhone: "",
        defaultDaysBeforeInvoiceDue: 30,
        invoiceDefaultNotes: "",
        closedPaidDuration: 60,
        showCommunityBaseAndHighPrice: true,
        showCommunitySecondPersonFee: true,
        showCommunityPetDeposit: true,
        showCommunityFee: true,
        showClientMonthlyBudget: true,
        showClientTotalFinances: true,
        partnerReferralsEnabled: false,
        faxCoverPageTemplateId: null,
        showClientSerial: false,
        clientDisclosureFileId: null,
        clientDisclosureSendTemplateId: null,
        clientDisclosureReceiptTemplateId: null,
        signatureRequestInitialTemplateId: null,
        signatureRequestCompleteTemplateId: null,
        alertClientsWithNoTasks: false,
        enableBulkCommunityOptions: false,
        "CommunityComparisonCommunityRow.showAddress": true,
        "CommunityComparisonCommunityRow.showPhone": true,
        "CommunityComparisonCommunityRow.showWebsite": true,
        "CommunityComparisonCommunityRow.showVirtualTour": true,
        timezone: defaultTimezone,
        intakeDisclosureLocation: "footer",
        enablePublicProfile: true,
        clientCollaborators: false,
        emailOptOut: false,
        trackTimeEnabled: false,
        timeTrackingIncrementMinutes: 15,
    };
}
export class Tenant {
    constructor() {
        this.tenantId = null;
        this.pdfDisclaimer = "";
        this.name = "";
        this.users = [];
        // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- legacy feature flags
        this.features = {};
        this.regions = [];
        this.whitelabel = {};
        this.hasFavicon = false;
        this.hasLogo = false;
        this.productName = "";
        this.billableEntityId = null;
        this.baaEnforced = false;
    }
    static fromDocument(doc) {
        const obj = new Tenant();
        obj.tenantId = doc.id;
        obj.pdfDisclaimer = doc.pdfDisclaimer;
        obj.name = doc.name;
        obj.features = doc.features;
        obj.regions = doc.regions.slice() || [];
        obj.whitelabel = doc.whitelabel;
        obj.hasFavicon = doc.hasFavicon;
        obj.hasLogo = doc.hasLogo;
        obj.productName = doc.productName;
        obj.billableEntityId = doc.billableEntityId;
        obj.baaEnforced = doc.baaEnforced ?? false;
        return obj;
    }
}
export const TenantLogoTypes = ["letterhead", "favicon", "logo"];
//# sourceMappingURL=tenant.js.map